<template>
  <title-container title="My Entities" icon="building">
    <b-row class="text-center">
      <b-col class="my-auto" cols="12">
        <div class="h4 text-danger">
          Click on Entity to see additional details and perform additional actions.
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-4 ml-5">
      <b-col class="mt-3" md="4" sm="12">
        <filter-table
          primary-key="id"
          empty-text="No Entities added."
          :fields="fields"
          :items="formattedEntitiesPending"
          :clickable="true"
          :slots="templates"
          @row-clicked="entityClicked"
        >
          <template slot="hint" >
            <div class="hint">
              PENDING
            </div>
          </template>
          <template slot="name" slot-scope="record">
            {{record.value}}
          </template>
        </filter-table>
      </b-col>
      <b-col class="mt-3" md="4" sm="12">
        <filter-table
          primary-key="id"
          empty-text="No Entities added."
          :fields="fields"
          :items="formattedEntitiesApproval"
          :clickable="true"
          :slots="templates"
          @row-clicked="entityClicked"
        >
          <template slot="hint">
            <div class="hint">
              APPROVED
            </div>
          </template>
          <template slot="name" slot-scope="record">
            {{record.value}}
          </template>
        </filter-table>
      </b-col>
      <b-col class="mt-3" md="4" sm="12">
        <new-entity
          class="new-entity-container"
          @entity-added="entityClicked"
          v-permission=permissionList
        />
      </b-col>
    </b-row>
  </title-container>
</template>

<script>
import helper from '@/libs/helper';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faBuilding } from '@fortawesome/free-solid-svg-icons';

import TitleContainer from '@/components/utils/TitleContainer';
import NewEntity from '@/components/entities/NewEntity';
import FilterTable from '@/components/utils/FilterTable';
import DashboardButton from '@/components/utils/buttons/navigation/DashboardButton';

import ENTITY_TYPES from '@/components/entities/resources/entityTypes.json';
import { ENTITY_WRITE } from '@/libs/permissions_list';


library.add(faBuilding);


export default {
  components: {
    TitleContainer,
    NewEntity,
    FilterTable,
    DashboardButton,
  },
  data() {
    return {
      fields: [
        { key: 'name', sortable: true },
        { key: 'type', sortable: true },
      ],
      templates: [
        { key: 'name' },
      ],
      permissionList: [ENTITY_WRITE],
    };
  },
  computed: {
    formattedEntitiesPending() {
      const entities = this.formatted();
      return entities.filter(entity => entity.docs.some(doc => doc.neededCount >= 1));
    },
    formattedEntitiesApproval() {
      const entities = this.formatted();
      return entities.filter(entity => !entity.docs.some(doc => doc.neededCount >= 1));
    },
  },
  methods: {
    formatted() {
      const entities = helper.copy(this.$store.getters.entities);
      return entities.map((entity) => {
        const fEntity = entity;
        fEntity.type = ENTITY_TYPES[entity.type];
        return fEntity;
      });
    },
    entityClicked(entity) {
      this.$router.push({ name: 'EntityDetails', params: { id: entity.id } });
    },
  },
};
</script>

<style scoped>
.hint {
  text-align: center;
  font-weight: bold;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/entities/EntitiesList.vue